import classNames from 'classnames';
import css from './ListingTags.module.css';

/**
 * A reusable tag component that displays a label with different visual styles
 * @param {Object} props
 * @param {string} props.label - The text to display inside the tag
 * @param {('default'|'white'|'green'|'blue'|'purple')} [props.variant='default'] - The visual style variant of the tag
 * @param {string} [props.className] - Additional CSS class to apply to the tag
 */
const Tag = ({ label, variant = 'default', className }) => {
  const tagClasses = classNames(
    css.tag,
    {
      [css.tag_white]: variant === 'white',
      [css.tag_green]: variant === 'green',
      [css.tag_blue]: variant === 'blue',
      [css.tag_purple]: variant === 'purple',
    },
    className
  );

  return <span className={tagClasses}>{label}</span>;
};

export default Tag;
